import { createTheme, adaptV4Theme } from '@mui/material/styles';
import * as globalStyles from './GlobalStyles';

const { colors, fonts } = globalStyles;

// Upgraded to MUI5 29 March 2022.
export const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: globalStyles.primaryColor,
        // dark: will be calculated from palette.primary.main,
        contrastText: globalStyles.whiteColor,
      },
      secondary: {
        main: colors.base3,
        // dark: will be calculated from palette.secondary.main,
        contrastText: colors.text1,
      },
      action: {
        disabledBackground: colors.base2,
      },
      // error: will use the default color
    },
    // see https://material-ui.com/customization/overrides/
    overrides: {
      // see https://material-ui.com/api/button/
      MuiButton: {
        root: {
          borderRadius: 18,
          textTransform: 'capitalize',
          fontFamily: fonts.primary,
          whiteSpace: 'nowrap',
        },
        containedSecondary: {
          color: colors.text1,
          backgroundColor: globalStyles.midGrayColor,
          '&:hover': {
            backgroundColor: colors.gray2, // what color should this highlight be?
          },
        },
        // withLinkStyle for ButtonView
        // flatSecondary: {
        // backgroundColor: 'inherit',
        // may play with background color for hover
        // deleting onHover decoration as color does not match text
        /*
        '&:hover': {
          textDecoration: 'underline'
        }
        */
        // },
        // todo may specifically style flatprimary and flatsecondary
        // and explicitly specify the primary and secondary styles where links are used
        // primary: black text vs secondary white text

        sizeSmall: {
          minWidth: '33px',
          minHeight: '33px',
          padding: '6px 8px',
        },
        sizeLarge: {
          borderRadius: 23,
          height: 46,
          padding: '0px 20px',
          fontSize: '17px',
        },
      },
      MuiFab: {
        sizeSmall: {
          width: '33px',
          minWidth: '33px',
          height: '33px',
          minHeight: '33px',
        },
        sizeLarge: {
          padding: '10px 24px',
          fontSize: '17px',
        },
      },
      MuiTooltip: {
        tooltip: {
          padding: 16,
          backgroundColor: globalStyles.midGrayColor, //colors.transparentBase4
        },
      },
      // https://material-ui.com/api/input/
      MuiInput: {
        root: {
          borderRadius: '4px',
          background: colors.base2,
          color: colors.text3, // trying with darker color for this
          fontFamily: fonts.primary,
          // boxShadow: 'inset 0px 2px 16px rgba(0, 0, 0, 0.05)',
          paddingLeft: '22px',
          height: '40px',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: colors.transparentOpp2,
          // transition: 'color .3s',
          '&$focused': {
            color: colors.text1,
          },
        },
        input: {
          height: 'initial',
        },
        fullWidth: {
          boxSizing: 'border-box',
        },
      },
      MuiTabs: {
        root: {
          color: colors.text3,
          padding: 0,
        },
        indicator: {
          backgroundColor: globalStyles.primaryColor,
          height: 4,
        },
      },
      MuiTab: {
        root: {
          fontFamily: fonts.primary,
          fontWeight: globalStyles.fontWeights.extraBold,
          fontSize: '13px',
          lineHeight: 'normal',
          textTransform: 'none',
          color: colors.text3,
          opacity: 1,
        },
        '&$selected': {
          color: colors.text1,
        },
      },
      MuiRadio: {
        root: {
          color: colors.text3,
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: colors.base3,
        },
      },
      MuiSwitch: {
        switchBase: {
          color: globalStyles.colors.text2,
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: globalStyles.primaryColor,
            opacity: 1,
          },
          '&.Mui-checked': {
            color: globalStyles.whiteColor,
          },
        },
      },
    },
  }),
);
